/**
 * Эталонная ΔT (°C) для строк клиентских пресетов — по какой разнице температур
 * подобран табличный расход flowRate (галочка «По стандартным изделиям»).
 */

import {
  HYDRAULIC_SEPARATOR_CLIENT_PARAMS_TABLE,
} from './hydraulicSeparatorClientParams';
import {
  DISTRIBUTION_COLLECTOR_CLIENT_PARAMS_TABLE,
} from './distributionCollectorClientParams';

export const CLIENT_THERMAL_DELTA_TEMP_CHOICES = [5, 10, 15, 20, 25];

export function normalizeClientThermalDeltaTemp(dt) {
  const n = Number(dt);
  if (CLIENT_THERMAL_DELTA_TEMP_CHOICES.includes(n)) return n;
  if (!Number.isFinite(n)) return 20;
  return CLIENT_THERMAL_DELTA_TEMP_CHOICES.reduce((best, v) =>
    (Math.abs(v - n) < Math.abs(best - n) ? v : best), 20);
}

export function getHydraulicSeparatorPresetReferenceDeltaTemp(presetKeyKw) {
  const row = HYDRAULIC_SEPARATOR_CLIENT_PARAMS_TABLE[presetKeyKw];
  const ref = row?.referenceDeltaTemp;
  return CLIENT_THERMAL_DELTA_TEMP_CHOICES.includes(ref) ? ref : 20;
}

export function getDistributionCollectorPresetReferenceDeltaTemp(presetKeyKw) {
  const row = DISTRIBUTION_COLLECTOR_CLIENT_PARAMS_TABLE[presetKeyKw];
  const ref = row?.referenceDeltaTemp;
  return CLIENT_THERMAL_DELTA_TEMP_CHOICES.includes(ref) ? ref : 20;
}

/** Узел коллектор+стрелка: эталон из таблицы гидроразделителя (единое поле ΔT на форме). */
export function getCwsPresetReferenceDeltaTemp(presetKeyKw) {
  return getHydraulicSeparatorPresetReferenceDeltaTemp(presetKeyKw);
}

export function applyHydraulicSeparatorClientPresetReferenceDelta(state, presetKeyKw) {
  if (presetKeyKw == null || !HYDRAULIC_SEPARATOR_CLIENT_PARAMS_TABLE[presetKeyKw]) return state;
  return { ...state, deltaTemp: getHydraulicSeparatorPresetReferenceDeltaTemp(presetKeyKw) };
}

export function applyDistributionCollectorClientPresetReferenceDelta(state, presetKeyKw) {
  if (presetKeyKw == null || !DISTRIBUTION_COLLECTOR_CLIENT_PARAMS_TABLE[presetKeyKw]) return state;
  return { ...state, deltaTemp: getDistributionCollectorPresetReferenceDeltaTemp(presetKeyKw) };
}

export function applyCwsClientPresetReferenceDelta(state, presetKeyKw) {
  return applyHydraulicSeparatorClientPresetReferenceDelta(state, presetKeyKw);
}

/** Подпись чекбокса: ΔT и номиналы из строки стандартного изделия. */
export const CLIENT_STANDARD_PRODUCTS_DELTA_TEMP_LABEL = 'По стандартным изделиям';

/** true — ΔT только из строки каталога (поле заблокировано); false — своя ΔT и пересчёт кВт. */
export function clientUsesPresetDeltaTemp(state) {
  if (state == null) return true;
  if (state.clientPresetDeltaTemp !== undefined) return Boolean(state.clientPresetDeltaTemp);
  return !Boolean(state.clientManualDeltaTemp);
}

const CLIENT_PRESET_WATER_CP = 4190;

/** Расход м³/ч для номинала пресета (кВт) при эталонной ΔT строки — как в калькуляторах (вода). */
export function clientPresetFlowM3hFromNominalPowerKw(powerKw, referenceDeltaTemp) {
  const p = Number(powerKw);
  const dt = normalizeClientThermalDeltaTemp(referenceDeltaTemp);
  if (!Number.isFinite(p) || p <= 0 || dt <= 0) return null;
  const flowM3h = (p * 1000) / (1000 * CLIENT_PRESET_WATER_CP * dt) * 3600;
  return parseFloat(flowM3h.toFixed(2));
}

/** Тепловая мощность (кВт) из расхода м³/ч и ΔT для воды. */
export function thermalPowerKwFromWaterFlowM3h(flowM3h, deltaTemp) {
  const dt = normalizeClientThermalDeltaTemp(deltaTemp);
  if (!Number.isFinite(flowM3h) || flowM3h <= 0 || dt <= 0) return null;
  const powerWatts = (flowM3h / 3600) * 1000 * CLIENT_PRESET_WATER_CP * dt;
  return parseFloat((powerWatts / 1000).toFixed(2));
}
